var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Banner',{attrs:{"info":_vm.bannerInfo}}),_c('Eq'),_c('Video',{attrs:{"ytId":"qHYYKmbHoO8"}}),_c('div',{attrs:{"id":"auto"}},_vm._l((_vm.autoInfo),function(info,i){return _c('Ad',{key:i,attrs:{"info":info}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }